/**
 * Page manager list types
 */

/**
 * Page manager list type content
 */
export const PM_LIST_TYPE_CONTENT = 'content'

/**
 * Page manager list type content people
 */
export const PM_LIST_TYPE_CONTENT_PEOPLE = 'content-people'

/**
 * Page manager list type content tags
 */
export const PM_LIST_TYPE_CONTENT_TAGS = 'content-tags'

/**
 * Page manager list type user portals
 */
export const PM_LIST_TYPE_PORTALS = 'portals'
